import React from 'react';

interface Props {
  children: React.ReactNode;
  onClick?: (e: any) => void;
  style?: React.CSSProperties;
}

const Pressable: React.FC<Props> = ({onClick, children, style}) => {
  return (
    <button
      onClick={onClick}
      style={{
        border: 'none',
        outline: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        ...style,
      }}>
      {children}
    </button>
  );
};

export default Pressable;
